import React, { useState } from 'react';
import { ContractTabProps } from 'routes/Contracts/ContractDetail/navigation-tab/contract-config-tabs';
import SubmissionCurrencyTab from 'components/features/submission-currency-tabs';
import { DEFAULT_CONVERSION_CURRENCY } from 'components/features/submission-details/types';
import OriginalPremiumSchedule from './original-premium-schedule';
import NoticeAndCommentForm from './notice-and-comment-form';
import PremiumPaidTable from 'components/features/contract/premium-processing/premium-paid-table';
import BalanceTable from 'components/features/contract/premium-processing/balance-table';

const PremiumProcessing: React.FC<ContractTabProps> = ({ contract }) => {
  const [activeTab, setActiveTab] = useState<string>(
    contract?.submission?.originalCurrency || DEFAULT_CONVERSION_CURRENCY
  );

  return (
    <div className="p-4 bg-white rounded-lg">
      <SubmissionCurrencyTab
        originalCurrency={contract?.submission?.originalCurrency}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        className="custom-tabs-with-bottom-curve-white"
        tabPosition="right"
      />
      <OriginalPremiumSchedule
        currency={activeTab}
        contractId={contract?.contractId}
      />
      <PremiumPaidTable
        currency={activeTab}
        contractId={contract?.contractId}
      />

      <BalanceTable currency={activeTab} contractId={contract?.contractId} />

      <NoticeAndCommentForm
        noticePeriod={contract?.noticeOfCancellationPeriod || 30}
        financeComments={contract?.financeComment}
        contractId={String(contract?.contractId)}
      />
    </div>
  );
};

export default PremiumProcessing;
